export default __webpack_public_path__ + "b61dc70c64610c230fd5c02e438b3b2f.svg";